module.exports = __webpack_public_path__ + "img/nav-icon-2.e1d89b3f.png";